var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAttachment = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31348 14.1667C2.83348 14.1667 0.813477 12.1467 0.813477 9.66667V5.66667C0.813477 2.82 3.13348 0.5 5.98014 0.5C8.82681 0.5 11.1468 2.82 11.1468 5.66667V9.33333C11.1468 10.8933 9.87348 12.1667 8.31348 12.1667C6.75348 12.1667 5.48014 10.8933 5.48014 9.33333V7C5.48014 6.72667 5.70681 6.5 5.98014 6.5C6.25348 6.5 6.48014 6.72667 6.48014 7V9.33333C6.48014 10.3467 7.30014 11.1667 8.31348 11.1667C9.32681 11.1667 10.1468 10.3467 10.1468 9.33333V5.66667C10.1468 3.36667 8.28014 1.5 5.98014 1.5C3.68014 1.5 1.81348 3.36667 1.81348 5.66667V9.66667C1.81348 11.5933 3.38014 13.1667 5.31348 13.1667C5.58681 13.1667 5.81348 13.3933 5.81348 13.6667C5.81348 13.94 5.59348 14.1667 5.31348 14.1667Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attachment.9fe8a399.svg";
export { ForwardRef as ReactComponent };